window.jQuery = window.$ = jQuery;

/*
 *
 *
 * 
 */
$ (function () {
    $ ('.guide-tab').on ('click', function () {

        var slug = $ (this).data ('guide');

        // Activate the tab
        $ ('.guide-tab').removeClass ('active');
        $ (this).addClass ('active');

        // Activate the guide
        $ ('.brew-guide').removeClass ('active');
        $ ('.brew-guide[data-guide=' + slug +']').addClass ('active');

        // console.log ($ (this).data ('guide'));
    });
});


document.addEventListener ('DOMContentLoaded', function () {

    if (document.getElementsByClassName ('brew-guide-tabs-wrapper').length) {

        var prevButton = document.getElementById ('prevButton');
        var nextButton = document.getElementById ('nextButton');

        var splide = new Splide ('.brew-guide-tabs-wrapper', {
            perPage: 2,
            mediaQuery: 'min',
            gap: '20px',
            breakpoints: {
                1200: {
                    destroy: true
                },
                712: {
                    perPage: 3
                }
            }
        }).mount ();
    }
});